import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const handleClick = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-5">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              {heroData.headline}
            </h1>

            <p className="mt-3 text-lg md:text-xl text-primary-600 font-medium">
              {heroData.slogan}
            </p>

            <div className="mt-6 space-y-3">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {heroData.description1}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {heroData.description2}
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={handleClick(heroData.primaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 bg-primary-600 text-background-50 font-semibold rounded-lg hover:bg-primary-700 transition-colors duration-200 text-sm whitespace-nowrap text-center"
              >
                {heroData.primaryCta.text}
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={handleClick(heroData.secondaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 border-2 border-primary-300 text-primary-700 font-semibold rounded-lg hover:bg-primary-50 transition-colors duration-200 text-sm whitespace-nowrap text-center"
              >
                {heroData.secondaryCta.text}
                <i className="ri-mail-send-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[350px] md:w-[360px] md:h-[450px] lg:w-[420px] lg:h-[520px] rounded-2xl overflow-hidden">
              <img
                src={heroData.heroImageUrl}
                alt="吃瓜网51 - 爆料黑料专区主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}